export enum SubmenuSections {
  BUSINESS = 'business',
  PAYMENTS = 'payments',
}
